/**
 * Inline icons. Stroke based, 24x24, currentColor, so they inherit the tab
 * colour and dark mode for free. Hand written rather than an icon package -
 * eleven icons is not worth a dependency.
 */

type Props = { className?: string }

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.7,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
}

export function HomeIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M3 10.2 12 3.5l9 6.7V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />
    </svg>
  )
}

export function CalendarIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </svg>
  )
}

export function BookIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M4 5a2 2 0 0 1 2-2h11v18H6a2 2 0 0 1-2-2z" />
      <path d="M17 3h2a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-2M8 8h5M8 12h5" />
    </svg>
  )
}

export function WalletIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <rect x="3" y="6" width="18" height="14" rx="2" />
      <path d="M3 10h18M16.5 14.5h.01" />
    </svg>
  )
}

export function ShieldIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M12 3 5 6v6c0 4.2 2.9 7.6 7 9 4.1-1.4 7-4.8 7-9V6z" />
      <path d="M9.5 12.2l1.8 1.8 3.4-3.6" />
    </svg>
  )
}

export function BellIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M6 9a6 6 0 0 1 12 0c0 4 1.5 5.5 1.5 5.5h-15S6 13 6 9Z" />
      <path d="M10 18a2 2 0 0 0 4 0" />
    </svg>
  )
}

export function GridIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
    </svg>
  )
}

export function UsersIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <circle cx="9" cy="8" r="3.2" />
      <path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5" />
      <path d="M16 5.3A3.2 3.2 0 0 1 16 11M18 14.8c2 .7 3 2.6 3 5.2" />
    </svg>
  )
}

export function CheckBadgeIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="m12 3 2.2 1.7 2.7-.2.6 2.7 2.2 1.6-1.2 2.5 1.2 2.5-2.2 1.6-.6 2.7-2.7-.2L12 21l-2.2-1.7-2.7.2-.6-2.7-2.2-1.6L5.5 12 4.3 9.5l2.2-1.6.6-2.7 2.7.2z" />
      <path d="m9.4 12.2 1.9 1.9 3.5-3.9" />
    </svg>
  )
}

export function MegaphoneIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M4 10v4a2 2 0 0 0 2 2h1l9 4V4L7 8H6a2 2 0 0 0-2 2Z" />
      <path d="M19 9.5a3 3 0 0 1 0 5M7 16v4" />
    </svg>
  )
}

export function ChevronLeftIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="m14.5 5-7 7 7 7" />
    </svg>
  )
}

export function LogoutIcon({ className }: Props) {
  return (
    <svg {...base} className={className}>
      <path d="M14 4h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />
      <path d="M10 8 6 12l4 4M6 12h10" />
    </svg>
  )
}
